import { IS_MOBILE } from "const/common";
import Image from "next/image";
import { useEffect, useState } from "react";

const StyleGuide = () => {
  const [isMobile, setIsMobile] = useState();
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
  }, []);

  return (
    <>
      <div className="py-16 px-4 md:pt-16 md:px-16 md:pb-0 bg-black">
        <div className="pl-2 md:p-16">
          <Image
            alt="pen"
            src="/assets/case-study/kyc/pen.webp"
            width={21}
            height={21}
          />
          <h3 className="text-3xl md:text-5xl font-medium text-white">
            <span className="font-ubuntu">Style Guide</span>
          </h3>
        </div>
      </div>
      <div className="bg-black pb-16 overflow-hidden">
        <div className="flex flex-col xl:flex-row items-center">
          <div className="w-full xl:w-1/2">
            <div>
              <h3 className="webkit-text-stroke-white opacity-20 text-5xl text-center md:text-9xl font-bold uppercase md:-ml-80">
                <span className="font-ubuntu">Typography</span>
              </h3>
              <span className="text-xl md:text-4xl font-medium font-ubuntu text-white pl-6 md:pl-32 relative top-8 md:-top-14">
                Ubuntu
              </span>
              <div className="pt-24 pl-6 md:pl-32 md:py-0">
                {isMobile !== null && isMobile ? (
                  <p className="text-lg font-normal text-white pb-4 opacity-80 relative -top-8">
                    <span className="font-ubuntu">
                      Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss
                      Tt Uu Vv Ww Xx Yy Zz
                    </span>
                  </p>
                ) : (
                  <p className="text-lg font-normal text-white font-ubuntu pb-4 opacity-80 relative -top-8">
                    <span className="font-ubuntu">
                      Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp <br /> Qq
                      Rr Ss Tt Uu Vv Ww Xx Yy Zz
                    </span>
                  </p>
                )}
                <p className="text-lg font-normal text-white font-ubuntu pb-4 opacity-80 relative -top-8">
                  <span className="font-ubuntu">1 2 3 4 5 6 7 8 9 0</span>
                </p>
                <div className="flex justify-between pr-8 md:pr-16">
                  <div>
                    <p className="text-lg font-light text-white">
                      <span>Ubuntu</span>
                    </p>
                    <p className="text-lg font-light text-white">
                      <span>
                        <i>Ubuntu</i>
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="text-lg font-normal text-white">
                      <span>Ubuntu</span>
                    </p>
                    <p className="text-lg font-normal text-white">
                      <span>
                        <i>Ubuntu</i>
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="text-lg font-medium text-white">
                      <span>Ubuntu</span>
                    </p>
                    <p className="text-lg font-medium text-white">
                      <span>
                        <i>Ubuntu</i>
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="text-lg font-bold text-white">
                      <span>Ubuntu</span>
                    </p>
                    <p className="text-lg font-bold text-white">
                      <span>
                        <i>Ubuntu</i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="py-40 md:-ml-16 text-end ml-0 text-5xl">
              <h3 className="webkit-text-stroke-white opacity-20 text-5xl text-center md:text-9xl font-bold uppercase md:-ml-80">
                <span className="font-ubuntu">ICONOGRAPHY</span>
              </h3>
              <div className="pt-16 pr-8 pl-4 md:pr-0 md:pt-16 md:pl-48">
                {isMobile ? (
                  <Image
                    alt="Iconography used in the app"
                    src={"/assets/case-study/kyc/icon-mobile.webp"}
                    width={342}
                    height={168}
                  />
                ) : (
                  <div className="text-start">
                    <Image
                      alt="Iconography used in the app"
                      src={"/assets/case-study/kyc/icon.webp"}
                      width={608}
                      height={126}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="w-full xl:w-1/2">
            <div className="xl:pt-40">
              <h3 className="webkit-text-stroke-white opacity-20 text-5xl md:text-9xl text-center md:text-end font-bold uppercase mr-4 md:-mr-10">
                <span className="font-ubuntu">Colors</span>
              </h3>
            </div>
            <div className="md:px-32 flex justify-evenly relative top-8 md:-top-12">
              <div className="w-5 md:w-7 h-[547px] bg-[#ceeafd] rounded-lg"></div>
              <div className="w-8 md:w-11 h-[547px] bg-[#d9d9d9] rounded-lg"></div>
              <div className="w-8 md:w-11 h-[547px] bg-[#fcc709] rounded-lg"></div>
              <div className="w-14 md:w-[70px] h-[547px] bg-[#0c69dc] rounded-lg"></div>
              <div className="w-14 md:w-[70px] h-[547px] bg-[#3554c2] rounded-lg"></div>
              <div className="w-20 md:w-24 h-[547px] rounded-lg bg-gradient-kyc-style-guide"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StyleGuide;
